import { createStore, applyMiddleware } from "redux"
import { createEpicMiddleware } from "redux-observable"
import { composeWithDevTools } from "@redux-devtools/extension"
import { createBrowserHistory } from "history"
import { routerMiddleware } from "connected-react-router"
import logger from "redux-logger"
import rootReducer from "./root-reducer"

import rootEpic from "./root-epic"

export const history = createBrowserHistory()

const makeStore = () => {
    const epicMiddleware = createEpicMiddleware()
    const middlewares = [epicMiddleware]

    middlewares.push(logger)

    const store = createStore(
        rootReducer(history),
        composeWithDevTools(
            applyMiddleware(...middlewares, routerMiddleware(history))
        )
    )

    epicMiddleware.run(rootEpic)

    return store
}

export default makeStore
